export const intuitBaseUrl = "/intuit/router";
export const intuitErrorUrl = "/intuit/quickbooks-error-page";

export const isAnIntuitError = () => window.location.pathname.indexOf(intuitErrorUrl) !== -1;
